import { defineConfig } from '@vueform/vueform'
import tailwind from '@vueform/vueform/themes/tailwind'
import en from '@vueform/vueform/locales/en'

export default defineConfig({
  theme: tailwind,
  locales: { en },
  locale: 'en',
  addClasses: {
    Form: {
      form: 'gap-y-5 gap-x-6',
    },
    TextElement: {
      input: 'input input-bordered w-full bg-base-100 h-10 min-h-[44px]',
    },
    DateElement: {
      input: 'input input-bordered w-full bg-base-100 h-10 min-h-[44px]',
    },
    TextareaElement: {
      input: 'textarea textarea-bordered w-full bg-base-100 min-h-[88px] py-3 text-sm',
    },
    ToggleElement: {
      toggle: 'toggle toggle-primary toggle-sm',
      text: 'text-sm font-medium ml-2 text-base-content'
    },
    SelectElement: {
      input: 'select select-bordered w-full bg-base-100 h-10 min-h-[44px] text-sm',
    },
    NumberElement: {
      input: 'input input-bordered w-full bg-base-100 h-10 min-h-[44px] font-mono text-sm',
    },
  },
  overrideClasses: {
    ElementLayout: {
      wrapper: 'mb-0', // Remove default bottom margins if applying grid gaps on the form directly
    },
    TextElement: {
      label: 'label-text text-[11px] font-bold uppercase tracking-widest text-base-content/80 mb-1 block',
    },
    SelectElement: {
      label: 'label-text text-[11px] font-bold uppercase tracking-widest text-base-content/80 mb-1 block',
    },
    DateElement: {
      label: 'label-text text-[11px] font-bold uppercase tracking-widest text-base-content/80 mb-1 block',
    },
    NumberElement: {
      label: 'label-text text-[11px] font-bold uppercase tracking-widest text-base-content/80 mb-1 block',
    },
    TextareaElement: {
      label: 'label-text text-[11px] font-bold uppercase tracking-widest text-base-content/80 mb-1 block',
    },
    ToggleElement: {
      label: 'label-text text-[11px] font-bold uppercase tracking-widest text-base-content/80 mb-2 block',
    }
  },
})
